/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import * as Sentry from "@sentry/react";
import { Route, RouteProps } from "react-router-dom";
import { createBrowserHistory } from "history";
import { BrowserTracing } from "@sentry/tracing";
import { SENTRY_TRACE_SAMPLE_RATE } from "src/config/constants";

const SentryRoute = Sentry.withSentryRouting(Route);

const history = createBrowserHistory();

Sentry.init({
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
  ],
  tracesSampleRate: SENTRY_TRACE_SAMPLE_RATE,
});

type Props = RouteProps;

const FlowioRoute: FC<Props> = ({ ...rest }) => <SentryRoute {...rest} />;

export default FlowioRoute;
export type FlowioRouteProps = Props;
